import React from "react";
import "./App.scss";
import i18n from "../i18next";
import AudiTheme from "../styles/theme/AudiTheme";
import AlfaRomeoTheme from "../styles/theme/AlfaRomeoTheme";
import BentleyTheme from "../styles/theme/BentleyTheme";
import BmwmoTheme from "../styles/theme/BmwmoTheme";
import BmwTheme from "../styles/theme/BmwTheme";
import BuerstnerTheme from "../styles/theme/BuerstnerTheme";
import CitroenTheme from "../styles/theme/CitroenTheme";
import DefaultTheme from "../styles/theme/DefaultTheme";
import DethleffsTheme from "../styles/theme/DethleffsTheme";
import FiatProTheme from "../styles/theme/FiatProTheme";
import FiatTheme from "../styles/theme/FiatTheme";
import FordTheme from "../styles/theme/FordTheme";
import GenesisTheme from "../styles/theme/GenesisTheme";
import HymerTheme from "../styles/theme/HymerTheme";
import HyundaiTheme from "../styles/theme/HyundaiTheme";
import JaguarTheme from "../styles/theme/JaguarTheme";
import JeepTheme from "../styles/theme/JeepTheme";
import KiaTheme from "../styles/theme/KiaTheme";
import LandRoverTheme from "../styles/theme/LandRoverTheme";
import MercedesTheme from "../styles/theme/MercedesTheme";
import MgTheme from "../styles/theme/MgTheme";
import MiniTheme from "../styles/theme/MiniTheme";
import MitsubishiTheme from "../styles/theme/MitsubishiTheme";
import NissanTheme from "../styles/theme/NissanTheme";
import OpelTheme from "../styles/theme/OpelTheme";
import PeugeotTheme from "../styles/theme/PeugeotTheme";
import PorscheTheme from "../styles/theme/PorscheTheme";
import SeatTheme from "../styles/theme/SeatTheme";
import SkodaTheme from "../styles/theme/SkodaTheme";
import SmartTheme from "../styles/theme/SmartTheme";
import SubaruTheme from "../styles/theme/SubaruTheme";
import VolkswagenTheme from "../styles/theme/VolkswagenTheme";
import VolvoTheme from "../styles/theme/VolvoTheme";
import RootNodeProvider from "../helper/RootNodeProvider";
import {I18nextProvider} from "react-i18next";
import LangSwitchProvider from "./LangSwitchProvider";
import DealerList from "./NSC/DealerList";

type DealerFinderProps = {}

class App extends React.Component<DealerFinderProps> {
	renderTheme(theme, children) {
		switch (theme) {
			case "audi" :
				return <AudiTheme>{children}</AudiTheme>;
			case "alfa romeo" :
				return <AlfaRomeoTheme>{children}</AlfaRomeoTheme>;
			case "volvo" :
				return <VolvoTheme>{children}</VolvoTheme>;
			case "bmw" :
				return <BmwTheme>{children}</BmwTheme>;
			case "bentley":
				return <BentleyTheme>{children}</BentleyTheme>;
			case "citroen" :
				return <CitroenTheme>{children}</CitroenTheme>;
			case "fiat" :
				return <FiatTheme>{children}</FiatTheme>;
			case "ford" :
				return <FordTheme>{children}</FordTheme>;
			case "genesis" :
				return <GenesisTheme>{children}</GenesisTheme>;
			case "hyundai" :
				return <HyundaiTheme>{children}</HyundaiTheme>;
			case "jaguar" :
				return <JaguarTheme>{children}</JaguarTheme>;
			case "jeep" :
				return <JeepTheme>{children}</JeepTheme>;
			case "kia" :
				return <KiaTheme>{children}</KiaTheme>;
			case "land rover" :
				return <LandRoverTheme>{children}</LandRoverTheme>;
			case "mitsubishi" :
				return <MitsubishiTheme>{children}</MitsubishiTheme>;
			case "nissan" :
				return <NissanTheme>{children}</NissanTheme>;
			case "opel" :
				return <OpelTheme>{children}</OpelTheme>;
			case "peugeot" :
				return <PeugeotTheme>{children}</PeugeotTheme>;
			case "seat":
				return <SeatTheme>{children}</SeatTheme>;
			case "smart":
				return <SmartTheme>{children}</SmartTheme>;
			case "subaru":
				return <SubaruTheme>{children}</SubaruTheme>;
			case "skoda" :
				return <SkodaTheme>{children}</SkodaTheme>;
			case "porsche" :
				return <PorscheTheme>{children}</PorscheTheme>;
			case "vw" :
				return <VolkswagenTheme>{children}</VolkswagenTheme>;
			case "mercedes":
				return <MercedesTheme>{children}</MercedesTheme>;
			case "mini":
				return <MiniTheme>{children}</MiniTheme>;
			case "fiatpro":
				return <FiatProTheme>{children}</FiatProTheme>;
			case "mg":
				return <MgTheme>{children}</MgTheme>;
			case "hymer":
				return <HymerTheme>{children}</HymerTheme>;
			case "bmwmo":
				return <BmwmoTheme>{children}</BmwmoTheme>;
			case "buerstner":
			case "bürstner":
				return <BuerstnerTheme>{children}</BuerstnerTheme>;
			case "dethleffs":
				return <DethleffsTheme>{children}</DethleffsTheme>;
			default:
				return <DefaultTheme>{children}</DefaultTheme>;
		}
	}

	render() {
		const dataset = RootNodeProvider.getDealerFinderRootNode().dataset;
		const {theme, dealerId, language, articleNumbers} = dataset;

		return (
			<I18nextProvider i18n={i18n}>
				{this.renderTheme(theme,
					<DealerList dealerNo={dealerId} theme={theme} articleNumbers={(articleNumbers || "").split(",")}/>
				)}
				<LangSwitchProvider language={language}/>
			</I18nextProvider>
		);
	}
}

export default App;
